__turbopack_context__.v({
  "arrow": "popover-module__JserOG__arrow",
  "dropdown": "popover-module__JserOG__dropdown",
});
